module.exports = __webpack_public_path__ + "static/media/短视频行业解决方案.78a56930.png";